<template>
    <div id="footer" class="text-center">
        <div class="badge bg-primary text-wrap" style="width: 6rem; margin-right: 5px;">
        2021, @zolv
        </div>
        <a href="http://vladzolo.fr">
        <img src="@/assets/logo-zolv.png" width="41" height="41" alt="zolv">
    </a>
    </div>
</template>

<style>
#footer {
   position:absolute;
   bottom:0;
   width:100%;
   height:41px;   /* Высота блока "footer" */
   background:#333333;
}
</style>
